<div class="shop-list">
    <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12" ng-repeat="shop in ctrl.shops track by $index" ng-class="{'shop-list-smart-store': shop.type == 'smartStore'}">
            <h3 class="shop-list-shop-name" ng-bind="::shop.name"></h3>
            <div class="shop-list-shop-description-outer">
                <p class="shop-list-shop-description" ng-bind-html="::shop.description"></p>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="shop-list-shop-program">
                        <span class="fa fa-clock-o"></span>
                        <span class="txtsm">&nbsp;Program azi</span>
                        <br>
                        <span class="shop-list-light-text" ng-bind="::shop.todaysProgram"></span></div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="shop-list-shop-distance" ng-show="::shop.distance">
                        <span class="fa fa-map-marker"></span>
                        <span class="txtsm">&nbsp;Distan&#539;a</span>
                        <br>
                        <span class="shop-list-light-text" ng-bind="::shop.distance"></span>
                    </div>
                </div>
            </div>
            <div class="shop-list-shop-details">
                <a role="button" class="btn btn-important shop-list-shop-details-btn btn-xs" href="javascript:void(0);" ng-click="ctrl.setShopToHighlightPosCode(shop.pos)">Arat&#259; pe hart&#259;</a>&nbsp;<a role="button" class="btn shop-list-shop-details-btn btn-xs" href="javascript:void(0);" ng-click="ctrl.goToShopDetailsPage(shop)">Vezi detalii</a>
            </div>
            <div class="shop-list-separator"></div>
        </div>
    </div>
</div>
